import { get } from '@utils/ajax';

/**
 * Layout Service
 * Handles layout switching and content loading
 */
const layoutService = (() => {
    // Switch layout
    const switchLayout = async fileName => {
        try {
            const response = await get(
                `${fileName}.php`,
                {
                    get_layout_only: true
                },
                {
                    showError: true,
                    dataType: 'text'
                }
            );
            return response;
        } catch (error) {
            return error;
        }
    };

    return {
        switchLayout
    };
})();

export default layoutService;
